module.exports = __webpack_public_path__ + "static/logo-bijeli-11916c215ca4ba5f6425ac10f5d32043.png";